import React from 'react';
import ME_ABOUT from '../../assets/me-about.jpg';

const About = () => {
  return (
    <section id="about">
      <div className="wrap">
        <div className="eyebrow"><span className="prompt">$</span> cat about.md</div>
        <h2 className="section-title">About me</h2>
        <p className="section-sub">The short version: I build full-stack products, but the backend — the part that moves money and tracks people — is where I spend most of my time.</p>

        <div className="about-grid reveal">
          <div>
            <div className="about-photo"><img src={ME_ABOUT} alt="Oluwaferanmi Idima" /></div>
          </div>
          <div className="about-body">
            <div className="stat-row">
              <div className="stat"><span className="num">4</span><span className="label">Roles &amp; ventures</span></div>
              <div className="stat"><span className="num">400+</span><span className="label">Users served (Nawo)</span></div>
              <div className="stat"><span className="num">3</span><span className="label">Shipped projects</span></div>
            </div>
            <p>I'm a fullstack developer with a backend major, based in Nigeria, currently building wallet and transaction infrastructure at <strong>Nawo</strong> and shipping full-stack features at <strong>Blended Technology Solutions</strong>. I co-founded <strong>UniXP</strong>, an edtech startup, and most recently spent my NYSC year at the <strong>Oyo State Governor's Office (MIC)</strong> teaching web development and building an LMS from scratch for the students I taught.</p>
            <p>I work comfortably across <strong>Node.js, NestJS, C# (.NET), and React</strong>, with PostgreSQL, MongoDB, and MySQL on the data side. I care more about whether a system holds up under real use than how it looks in a demo — though I try not to neglect either.</p>
            <a href="#contact" className="btn btn-outline">Let's talk →</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;